import { User } from "@/model/User";

export interface AuthState {
    me: User;
}

const state: AuthState = {
    me: null,
};

export default state;